// extracted by mini-css-extract-plugin
export default {"root":"ParticipantList_root__wyxc1","list":"ParticipantList_list__qkult"};